
import { useState } from 'react'

import { CartCheckout } from './CartCheckout'
import { CartConfirm } from './CartConfirm'


export const UserCartScreen = () => {
  const [first, setfirst] = useState(true)


  return (
    <section className='_cart animate__animated animate__fadeIn page-content'  >

      
      <div className='container mt-3'> 

        Seccion en Mantenimiento
      </div>

      {/* {first&&
      
        <CartConfirm setfirst={ setfirst }/>
      }

      {!first&&
        
        <CartCheckout setfirst={ setfirst } />
      }

    */}
    </section>
  )
}
